"use client";

import { MapPin, Mail, Phone } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactInformation() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const locations = [{
    id: 1,
    name: "Rathnew Garage",
    address: "Ballybeg, Rathnew A67Y602",
    phone: "0876789903"
  }, {
    id: 2,
    name: "Blainroe Garage",
    address: "Blainroe - Old Vartry Garage",
    phone: "0876789903"
  }, {
    id: 3,
    name: "Wicklow Town Garage",
    address: "New Street Wicklow Town",
    phone: "0876253228"
  }];
  return <section id="contact-information" ref={sectionRef} className="bg-background py-16 md:py-24">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div className="space-y-6">
            {locations.map((location, i) => <div key={location.id} data-index={i} className={`transition-all duration-[150ms] ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: sectionVisible ? `${i * 100}ms` : "0ms"
          }}>
                <Card className="card hover-lift">
                  <CardContent className="flex items-start gap-4 p-6">
                    <div className="flex-shrink-0 w-12 h-12 rounded-md bg-primary-light flex items-center justify-center">
                      <MapPin className="w-6 h-6 text-primary" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <h3 className="font-display font-semibold text-lg text-foreground mb-2">
                        {location.name}
                      </h3>
                      <p className="text-muted-foreground text-sm mb-3">
                        {location.address}
                      </p>
                      <Link to={`tel:${location.phone}`} className="inline-flex items-center gap-2 text-primary hover:text-primary-hover font-semibold text-base transition-colors duration-[var(--duration-fast)] focus-ring">
                        <Phone className="w-5 h-5" />
                        {location.phone}
                      </Link>
                    </div>
                  </CardContent>
                </Card>
              </div>)}
          </div>

          {}
          <div className={`space-y-6 transition-all duration-[150ms] ease-out ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
          transitionDelay: sectionVisible ? "300ms" : "0ms"
        }}>
            {}
            <Card className="card">
              <CardContent className="flex items-start gap-4 p-6">
                <div className="flex-shrink-0 w-12 h-12 rounded-md bg-secondary-light flex items-center justify-center">
                  <Mail className="w-6 h-6 text-secondary-dark" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-display font-semibold text-lg text-foreground mb-2">
                    Email Us
                  </h3>
                  <p className="text-muted-foreground text-sm mb-3">
                    For general inquiries and service requests
                  </p>
                  <Link to="mailto:info@markjohnstonmotors.ie" className="text-primary hover:text-primary-hover font-semibold transition-colors duration-[var(--duration-fast)] focus-ring">mjmwicklow@gmail.com</Link>
                </div>
              </CardContent>
            </Card>

            {}
            <Card className="card overflow-hidden">
              <div className="relative w-full h-[400px] bg-muted">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2402.5820294756447!2d-6.0435673!3d52.9798889!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4867566c6b3e3e3f%3A0x0!2zNTLCsDU4JzQ3LjYiTiA2wrAwMiczNi44Ilc!5e0!3m2!1sen!2sie!4v1234567890&q=New+Street+Wicklow+Town+Ireland" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Wicklow Town Garage - New Street Location" className="absolute inset-0"></iframe>
              </div>
            </Card>
          </div>
        </div>
      </div>
    </section>;
}